import { ATTENTION_COLOR, Notification } from '@any-ui-react/core';
import { type ReactNode, useMemo } from 'react';
import { MaterialIcons } from '../material-icons';

type AlertBannerType = 'info' | 'success' | 'warning' | 'error';

export interface AlertBannerProps {
  type: AlertBannerType;
  title?: ReactNode;
  children?: ReactNode;
  loading?: boolean;
  onClose?: () => void;
  withCloseButton?: boolean;
  className?: string;
}

const alertBannerColorIcon: Record<AlertBannerType, [string, ReactNode]> = {
  info: [ATTENTION_COLOR.info, <MaterialIcons key="info" iconName="info" fill={true} fontSize="16px" />],
  success: [
    ATTENTION_COLOR.success,
    <MaterialIcons key="success" iconName="check_circle" fill={true} fontSize="16px" />,
  ],
  warning: [ATTENTION_COLOR.warning, <MaterialIcons key="warning" iconName="warning" fill={true} fontSize="16px" />],
  error: [ATTENTION_COLOR.error, <MaterialIcons key="error" iconName="error" fill={true} fontSize="16px" />],
};

export const AlertBanner = ({
  title,
  children,
  loading,
  onClose,
  withCloseButton = false,
  type,
  className,
}: AlertBannerProps) => {
  const [color, Icon] = useMemo(
    () =>
      alertBannerColorIcon[type] || [
        ATTENTION_COLOR.error,
        <MaterialIcons key="0" iconName="error" fill={true} fontSize="16px" />,
      ],
    [type],
  );

  return (
    <Notification
      className={className}
      color={color}
      icon={Icon}
      loading={loading}
      title={title}
      withBorder={true}
      withCloseButton={withCloseButton}
      onClose={onClose}
    >
      {children}
    </Notification>
  );
};
